<!----------------Editorial    -->
<section id="editorial" class="editorial pt-5 mt-5 pb-0" aria-label="editorial"
	*ngIf=" editorsDetailsLength!==0;else nodata">
	<div class="container-fluid">
		<div class="row  pb-5">

			<div class="col" *ngIf="loading">
				<div class="d-flex justify-content-center">
					<div>
						<h2 class="primary ml-3 content-loader">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</h2>
						<p class="rvh-sub-heading content-loader" *ngIf="loading">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</p>
					</div>
				</div>
			</div>
			<div class="col" *ngIf="!loading">
				<div class="section-title col" data-aos="fade-up">
					<div class="d-flex justify-content-center">
						<div>
							<h2 class="primary ml-3 mt-5" *ngIf="!loading">
								{{'journal_home.Editorial_heading'|translate}}
							</h2>

							<p class="rvh-sub-heading" *ngIf="!loading">
								{{'journal_home.Editorial_sub_heading'|translate}}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row" *ngIf="loading"> <!----------------content section --------------->
			<section class=" w-100" id="editor-details" class="p-0 pt-3">
				<div class="row border-bottom ">
					<div class="col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3  mb-5 p-0 pb-5" id="editors"
						*ngFor="let eachdata of editorial_loader; let i=index">
						<div class="row">
							<div class="col-12">
								<div class="row">
									<div class="col d-flex justify-content-center">
										<div class="outer-circle content-loader"
											style=" border-radius: 50%; border:none">
											<div class="inner-circle">
												<img class="image-container">
											</div>
											<div class="small-circle"
												style="background: linear-gradient(to right, #deebff66 20%, #deebff 50%, #deebffed 80%);">
											</div>
										</div>
									</div>
								</div>
								<div class="row ">
									<div class="col d-flex justify-content-center">
										<div class="editor-details">

											<div class="d-flex justify-content-center">
												<span class="editor-name  pt-2 content-loader">
													<!---------------Page loading loader---------->
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</span>
											</div>
											<div class="d-flex justify-content-center">
												<p class="editor-designation  m-0 pt-1 content-loader">
													<!---------------Page loading loader---------->
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</p>
											</div>
											<div class="d-flex justify-content-center ">
												<!---------------Page loading loader---------->
												<div class=" m-0 pt-1 text-para pl-2 content-loader">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</div>
											</div>
											<div class="d-flex justify-content-center pt-2">
												<!---------------Page loading loader---------->
												<span class="content-loader">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</span>
												<span class="content-loader">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</span>
												<span class="content-loader">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</span>
												<span class="content-loader">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<div class="row" *ngIf="!loading"> <!--------------------Content section------------------>
			<div *ngFor="let data of editorsDetails; let j=index">
				<!-- <div class="postion-relative">
					<img class=""  width="138" height="107" src="assets/images/graphics.webp" [alt]="'graphicsimage'" aria-hidden="true" width>
				</div> -->
				<section class=" w-100" id="editor-details" class="p-0 pt-3">
					<div class="row ml-5  border-bottom " *ngIf="data.name==='meet_the_editors'">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 mb-5 p-0 pb-5 mx-auto" id="editors"
							*ngFor="let eachdata of data.editorials; let i=index"
							[ngStyle]="{'border-bottom': (data.editorials.length > 4    ) ? '2px solid #dee2e6' : 'none'}">
							<!-- <div class="row">
								<div class="col-12 ">
									<div class="row"> -->
							<div class="col d-flex justify-content-center">
								<div class="outer-circle">
									<div class="inner-circle" (click)="getDetails(eachdata)">
										<img class="image-container"  src="{{editorsImageUrl}}{{eachdata.image}}" width="100" height="100"
											[alt]="eachdata.alt_text">
									</div>
									<div class="small-circle"></div>
								</div>
							</div>
							<!-- </div> -->
							<div class="row ">
								<div class="col d-flex justify-content-center">
									<div class="editor-details">

										<div class="justify-content-center">
											<div class="editor-name  pt-2 text-center" [innerHTML]="checkProfesor(eachdata.name)"></div>
											<div class="editor-name  text-center d-flex justify-content-center"  [innerHTML]="checkName(eachdata.name)"></div>
										</div>
										<div class="d-flex justify-content-center">
											<p class="editor-designation  m-0 pt-1">
												{{eachdata.designation}}</p>
										</div>
										<div class="d-flex justify-content-center ">
											<div class=" m-0 pt-1 text-para pl-2 description-section"
												 [innerHTML]=eachdata.descrption>
											</div>
										</div>
										<div class="d-flex justify-content-center pt-2">
											<!-- Tooltip for ORCID -->
											<span *ngIf="eachdata.orcid" [ngbTooltip]="eachdata.orcid"
												placement="bottom" (click)="openOrcidLink(eachdata.orcid)">
												<img src="assets/logos/orcid_logo.png" class="pl-3 editors-icon" alt="ORCID">
											</span>
											<!-- Tooltip for Phone -->
											<span *ngIf="eachdata.phone" [ngbTooltip]="eachdata.phone"
												placement="bottom">
												<fa-icon [icon]="['fas','phone']" class="pl-3 editors-icon"></fa-icon>
											</span>
											<!-- Tooltip for Email -->
											<span *ngIf="eachdata.email" [ngbTooltip]="eachdata.email"
												placement="bottom">
												<!-- <a [href]="'mailto:' + eachdata.email" target="_blank"> -->
													<fa-icon [icon]="['fas','envelope']"
														class="pl-3 editors-icon"></fa-icon>
												<!-- </a> -->
											</span>
											<!-- Tooltip for Website -->
											<span *ngIf="eachdata.website" [ngbTooltip]="eachdata.website"
												placement="bottom">
												<a target="_blank" [href]="ensureHttps(eachdata.website)">
													<fa-icon [icon]="['fas','globe']"
														class="pl-3 pr-3 editors-icon"></fa-icon></a>
											</span>
										</div>

									</div>
								</div>
							</div>
							<!-- </div>
							</div> -->
						</div>
					</div>
				</section>
			</div>
		</div>
		<section class=" w-100" id="editor-details" *ngIf="!loading" class="p-0 pt-3">
			<div class="section-title-editorial col" data-aos="fade-up">
				<div class="d-flex justify-content">
					<div class="margin-heading">
						<h2 class="primary ml-3 " *ngIf="!loading">EDITORIAL BOARD</h2>
						<!-- <p class="rvh-sub-heading">
							{{'journal_home.Editorial_sub_heading'|translate}}
						</p> -->
					</div>
				</div>
			</div>
		</section>
		<!-- loading -->
		<section class=" w-100 pb-0"  *ngIf="loading">
			<div class="section-title-editorial col">
				<div class="d-flex justify-content">
					<div>
						<h2 class="primary ml-5 content-loader">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</h2>

					</div>
				</div>
			</div>
		</section>
		<div class="row" *ngIf="!loading">
			<div *ngFor="let data of editorsDetails; let j=index">
				<!-- <div class="postion-relative">
					<img  width="138" height="107"  class="" src="assets/images/graphics.webp" [alt]="'graphicsimage'" aria-hidden="true">
				</div> -->
				<section class=" w-100" id="editor-details" class="p-0 pt-3">
					<div class="row ml-5  border-bottom " *ngIf="data.name==='editorial_board'">
						<div class="col-12 col-lg-6 col-md-6 col-sm-12 col-xl-4 p-0 pb-4" id="editors"
							*ngFor="let eachdata of data.editorials; let i=index; let last = last">
							<!-- [ngStyle]="{'border-bottom': (data.editorials.length > 4 && !last) ? '2px solid #dee2e6' : 'none'}" -->
							<!-- <div class="row">
								<div class="col-12">
									<div class="row"> -->
							<!-- <div class="col d-flex justify-content-center">
								<div class="outer-circle">
									<div class="inner-circle">
										<img class="image-container" src="{{editorsImageUrl}}{{eachdata.image}}"
											[alt]="eachdata.alt_text">
											
									</div>
									<div class="small-circle"></div>
								</div>
							</div> -->
							<!-- </div> -->
							<div class="row ">
								<div class="col d-flex justify-content">
									<div class="editor-details padding-margin-editors">
										<!-- <div class="d-flex justify-content" (click)="getDetails(eachdata)"> -->
										<div class="d-flex justify-content " >
											<span class="editor-name pt-2">{{eachdata.name
												| uppercase}}</span>
										</div>
										<div class="d-flex justify-content">
											<p class="editor-designation m-0 pt-1 mb-2">
												{{eachdata.designation}}</p>
										</div>
										<!-- <div class="d-flex justify-content-center ">
											<div class=" m-0 pt-1 text-para pl-2 text-center"
												(click)="getDetails(eachdata)" [innerHTML]=eachdata.descrption>
											</div>
										</div> -->
										<!-- <div class="d-flex justify-content-center pt-2"> -->
										<!-- Tooltip for ORCID -->
										<!-- <span *ngIf="eachdata.orcid" [ngbTooltip]="eachdata.orcid"
												placement="bottom" (click)="openOrcidLink(eachdata.orcid)">
												<img src="assets/logos/orcid_logo.png" class="pl-3 editors-icon" alt="ORCID">
											</span> -->
										<!-- Tooltip for Phone -->
										<!-- <span *ngIf="eachdata.phone" [ngbTooltip]="eachdata.phone"
												placement="bottom">
												<fa-icon [icon]="['fas','phone']" class="pl-3 editors-icon"></fa-icon>
											</span> -->
										<!-- Tooltip for Email -->
										<!-- <span *ngIf="eachdata.email" [ngbTooltip]="eachdata.email"
												placement="bottom">
												<a [href]="'mailto:' + eachdata.email" target="_blank">
													<fa-icon [icon]="['fas','envelope']"
														class="pl-3 editors-icon"></fa-icon>
												</a>
											</span> -->
										<!-- Tooltip for Website -->
										<!-- <span *ngIf="eachdata.website" [ngbTooltip]="eachdata.website"
												placement="bottom">
												<a target="_blank" [href]="ensureHttps(eachdata.website)">
													<fa-icon [icon]="['fas','globe']"
														class="pl-3 pr-3 editors-icon"></fa-icon></a>
											</span> -->
										<!-- </div> -->
									</div>
								</div>
							</div>
							<!-- </div>
							</div> -->
						</div>
					</div>
				</section>
			</div>
		</div>
		<!-- loading -->
		<div class="row" *ngIf="loading">
			<div>
				<!-- <div class="postion-relative">
					<img  width="138" height="107" class="" src="assets/images/graphics.webp" [alt]="'graphicsimage'" aria-hidden="true">
				</div> -->
				<section class=" w-100" id="editor-details" class="p-0 pt-3">
					<div class="row ml-5  border-bottom ">
						<div id="editors" class="col-12 col-lg-4 col-md-6 col-sm-12 col-xl-4 mb-5 p-0 pb-5"
							*ngFor="let eachdata of editorial_loader; let i=index">
							<div class="row">
								<div class="col d-flex justify-content">
									<div class="editor-details">
										<div class="d-flex justify-content">
											<p class="editor-designation  m-0 pt-1 mb-2 content-loader">
												<!---------------Page loading loader---------->
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											</p>
										</div>
										<div class="d-flex justify-content ">
											<!---------------Page loading loader---------->
											<div class=" m-0 pt-1 text-para pl-2 content-loader">
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</section>

<ng-template #nodata>
	<div class="container margin-top" [style.height.px]="containerHeight">
		<div class="row  pb-5">
			<div class="section-title col" data-aos="fade-up">
				<div class="d-flex justify-content-center ">

					<div>
						<h2 class="primary ml-3">{{'journal_home.Editorial_heading'|translate}}</h2>
						<p class="rvh-sub-heading">
							{{'journal_home.Editorial_sub_heading'|translate}}
						</p>
					</div>

				</div>

			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-12 text-center">
				<div style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
					<img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.webp" alt="">
					<h5 class="card-title Roboto-medium text-head-size">No data found</h5>
				</div>
			</div>
		</div>
	</div>
</ng-template>